import React, { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import API from '../../config/config';
import Slider from 'react-slick';

const SampleNextArrow = (props: any) => {
  const { onClick } = props;
  return (
    <button onClick={() => onClick()} className="btncarousel-widget btncarousel-widget-arrow-right">
      <span className="fas fa-chevron-right " />
    </button>
  );
};

const SamplePrevArrow = (props: any) => {
  const { onClick } = props;
  return (
    <button onClick={() => onClick()} className="btncarousel-widget btncarousel-widget-arrow-left">
      <span className="fas fa-chevron-left  " />
    </button>
  );
};

const ProductUsageCardWidget = (props: any) => {


  var settings = {
    dots: true,
    arrows: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: 0,
    adaptiveHeight: true,


    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />
  };

  const windowSize = useWindowSize();
  function useWindowSize() {
    const [dimension, setDimensions] = useState({
      height: undefined,
      width: undefined
    });

    useEffect(() => {
      const handleResize = () => {
        setDimensions({
          height: window.innerHeight,
          width: window.innerWidth
        });
      };

      window.addEventListener('resize', handleResize);
      handleResize()
      return () => {
        window.removeEventListener('resize', handleResize);
      };
    }, []);
    return dimension
  }

  return (
    <React.Fragment>
      <div className={windowSize.width >= 780 ? 'show' : 'hide'}>
        <div
          className="ProductUseageCard-background"
          style={{ backgroundImage: 'url(' + API.baseUrl + props.data.backgroundImage.url + ')' }}
        >
          <div className="container-fluid">
            <div className="container">
              <h2 className="ProductUseageCard-h2">{props.data.title}</h2>
              <h4 className="ProductUseageCard-h4">{props.data.subTitle} </h4>
              <Row sm={3} xs={1}>
                {props.data.CardImageInfo.map((items: any, i: number) => {
                  return (
                    <Col key={i}>
                      <div className="ProductUseageCard-flex-container">
                        <div>
                          <img className="ProductUseageCard-number-img" src={API.baseUrl + items.numberIcon.url} alt={API.baseUrl + items.numberIcon.url} />
                        </div>
                        <div>
                          <img className="ProductUseageCard-img " src={API.baseUrl + items.image.url} alt={API.baseUrl + items.image.url} />
                        </div>
                        <div>
                          <h4 className="ProductUseageCard-h4">{items.title}</h4>
                        </div>
                        <div>
                          <h6 className="ProductUseageCard-h6">{items.subTitle}</h6>
                        </div>
                      </div>
                    </Col>
                  );
                })}
              </Row>
            </div>
          </div>
        </div>
      </div>

      <div className={windowSize.width < 780 ? 'show' : 'hide'}>
        <div
          className="ProductUseageCard-background"
          style={{ backgroundImage: 'url(' + API.baseUrl + props.data.backgroundImage.url + ')' }}
        >
          <div className="container-fluid">
            <div className="container">
              <h2 className="ProductUseageCard-h2">{props.data.title}</h2>
              <h4 className="ProductUseageCard-h4">{props.data.subTitle} </h4>
              <Slider {...settings}>
                {props.data.CardImageInfo.map((items: any, i: number) => {
                  return (
                    <Col key={i}>
                      <div className="ProductUseageCard-flex-container">
                        <div>
                          <img className="ProductUseageCard-number-img" src={API.baseUrl + items.numberIcon.url} alt={API.baseUrl + items.numberIcon.url} />
                        </div>
                        <div>
                          <h4 className="ProductUseageCard-h4">{items.title}</h4>
                        </div>
                        <div>
                          <h6 className="ProductUseageCard-h6">{items.subTitle}</h6>
                        </div>
                        <div>
                          <img className="ProductUseageCard-img " src={API.baseUrl + items.image.url} alt={API.baseUrl + items.image.url} />
                        </div>
                      </div>
                    </Col>
                  );
                })}

              </Slider>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ProductUsageCardWidget;
